import { createSlice } from "@reduxjs/toolkit";

let initialState = [];

const checkedDataSlice = createSlice({
  name: "checkedData",
  initialState: initialState,
  reducers: {
    checkedTrue: (state, action) => {
      if (
        state.some(
          (item) =>
            item.module_id === action.payload.module_id &&
            item.role_id === action.payload.role_id &&
            item.action_type === action.payload.action_type
        )
      ) {
        return state.map((item) => {
          if (
            item.module_id === action.payload.module_id &&
            item.role_id === action.payload.role_id &&
            item.action_type === action.payload.action_type
          ) {
            return {
              ...item,
              access_flag: 1,
            };
          }
          return item;
        });
      } else {
        const obj = {
        ...action.payload,
          access_flag: 1,
        };
        state.push(obj);
        return state;
      }
    },
    checkedFalse: (state, action) => {
      if (
        state.some(
          (item) =>
            item.module_id === action.payload.module_id &&
            item.role_id === action.payload.role_id &&
            item.action_type === action.payload.action_type
        )
      ) {
        return state.map((item) => {
          if (
            item.module_id === action.payload.module_id &&
            item.role_id === action.payload.role_id &&
            item.action_type === action.payload.action_type
          ) {
            return {
              ...item,
              access_flag: 0,
            };
          }
          return item;
        });
      } else {
        const obj = {
          ...action.payload,
         
          access_flag: 0,
        };
        state.push(obj);
        return state;
      }
    },
  },
});
export const { checkedFalse, checkedTrue } = checkedDataSlice.actions;
export default checkedDataSlice.reducer;
